import {TweenMax, Power4} from 'gsap';

export default class MobileNavigation {
    constructor() {
        this.menu = document.querySelector('.js-nav-menu');
        this.btn = document.querySelector('.js-nav-btn');
        this.isOpened = false;
        this.body = document.querySelector('body');

        if (this.menu && this.btn) {
            this.init();
        }
    }

    init() {
        this.btn.addEventListener('click', () => {
            if (this.isOpened) {
                this.isOpened = false;
                this.closeNav();
                return;
            }

            this.openNav();
            this.isOpened = true;
        });
    }

    closeNav() {
        this.btn.classList.remove('is-active');
        TweenMax.to(this.menu, 0.7, {
            y: "-100%",
            ease: Power4.easeOut
        });

        this.unlockScroll();
    }

    openNav() {
        this.btn.classList.add('is-active');
        TweenMax.to(this.menu, 0.8, {
            y: "0%",
            ease: Power4.easeOut
        });

        this.lockScroll();
    }

    lockScroll() {
        this.offsetTop = document.documentElement.scrollTop;
        this.body.style.overflow = 'hidden';
        this.body.style.top = `-${document.documentElement.scrollTop}px`;
        this.body.style.position = 'fixed';

    }

    unlockScroll() {
        this.body.style.top = '0px';
        this.body.style.position = '';
        this.body.style.overflow = '';
        document.documentElement.scrollTop = this.offsetTop;
    }
}
